import api from '../../helper/api';
import store from '../index';

export default {
    module: {
        namespaced: true,

        state: {
            rules: {}
        },
        getters: {
            modelRules: (state) => (model) => {
                return model in state.rules ? state.rules[model] : null;
            },
        },
        mutations: {
            addModelRules(state, data) {
                state.rules[data.model] = data.rules;
            }
        },
        actions: {
            async loadRules({ getters, commit }, model) {
                return new Promise((resolve, reject) => {
                    let rules = getters.modelRules(model);

                    if (rules) {
                        resolve(rules);
                    } else {

                        api.get(`validation/${model}`).run().then(apiResponse => {
                            commit('addModelRules', { model: model, rules: apiResponse.data });

                            resolve(apiResponse.data);
                        }, error => {
                            reject(error);
                        });
                    }
                });
            }
        }
    }
}